package com.eladfinish.bible.contest.utils

/** Hebrew numeral punctuation: "א" → "א'", "יא" → "י\"א". */
fun String.addGershaim() = when (length) {
    0 -> this
    1 -> this.plus("'")
    else -> this.take(length - 1).plus("\"").plus(this[length - 1])
}
